const constants = {
  maxValues: {
    input: {
      borderRadius: 15,
    },
    textarea: {
      borderRadius: 15,
    },
    notice: {
      borderRadius: 15,
    },
    card: {
      borderRadius: 15,
    },
  },
  defaults: {
    input: {
      borderRadius: 0,
      borderColor: "black",
    },
    textarea: {
      borderRadius: 0,
      borderColor: "black",
    },
    button: {
      background: "black",
      boxShadow: "5px 5px black",
    },
    notice: {
      borderRadius: 0,
      boxShadow: "none",
    },
    card: {
      borderRadius: 0,
      boxShadow: "none",
    },
    link: {
      color: "black",
      hover: {
        color: "black",
      },
    },
  },
  nonExportedCss:
    "transition: border-radius 200ms, box-shadow 200ms;" /* used for nice UX. Not actually exported */,
};

export default constants;
